import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class SecurepayPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  billType: string;
  accountName: string;

  constructor(
    options?: Partial<SecurepayPaymentProcessorAccountConfiguration>
  ) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }
  }
}
